import defaultConfig from './default';
// import productionConfig from './production';

const config =  defaultConfig;

export default config;
